module.exports = __webpack_public_path__ + "static/media/dropdown-blue.b20914ec.svg";